import { Box }                            from '@chakra-ui/react';
import { Dispatch }                       from 'react';
import { Grid }                           from '@chakra-ui/react';
import { GridItem }                       from '@chakra-ui/react';
import { IconButton }                     from '@chakra-ui/react';
import { Image }                          from '@chakra-ui/react';
import { LuMenu }                         from "react-icons/lu";
import NavBarAvatar                       from '@/components/navbar/components/NavBarAvatar';
import NavBarSearchInput                  from '@/components/navbar/components/NavBarSearchInput';
import NavBarUserName                     from '@/components/navbar/components/NavBarUserName';
import SelectLanguage                     from '../select-language/SelectLanguage';
import { SetStateAction }                 from 'react';
import { SystemStyleObject }              from '@chakra-ui/react';
import logo                               from '@/assets/images/logo-white.png';
import useScreenSize                      from '@/hooks/useScreenSize';
import { Link }                           from 'react-router-dom';

interface INavBarProps {
    setIsOpen: Dispatch<SetStateAction<boolean>>;
}

const NavBar = (props: INavBarProps) => {
    const { setIsOpen } = props;
    const { isLG } = useScreenSize();

    return (
        <Box 
            {...styles.container.base}
            as="nav"
        >
            <Grid
                gridTemplateColumns={{ base: "0.3fr 0.4fr 0.3fr", lg: "0.5fr 0.5fr" }}
                height="100%"
            >
                <GridItem
                    alignContent="center"
                    hideFrom="lg"
                    justifySelf="start"
                    paddingLeft={{ base: "3px", lg: "20px" }}
                >
                    <IconButton variant="ghost" size="2xl" onClick={() => setIsOpen(true)}>
                        <LuMenu color="white" opacity="80%" />
                    </IconButton>
                </GridItem>

                <GridItem
                    alignContent="center"
                    justifySelf={{ base: "center", lg: "start" }}
                    paddingLeft={{ base: 0, lg: "30px" }}
                >
					<Link to="/">
						<Image src={logo} width={230} />
					</Link>
                </GridItem>

                <GridItem
                    alignContent="center"
                    justifySelf="end"
                    paddingRight={{ base: "3px", lg: "20px" }}
                >
                    <Box
                        display="flex"
                        alignItems="center"
                        gap={{ base: "10px", lg: "20px" }}
                    >
                        <NavBarSearchInput />
                        {isLG && <NavBarAvatar />}
                        <NavBarUserName />
                        <SelectLanguage 
                            borderColor='rgba(112, 112, 112, 0.6)'
                            color='white'
                        />
                    </Box>
                </GridItem>
            </Grid>
        </Box>
    )
}

export default NavBar;

const styles: {
	[key: string]: {
		[key: string]: SystemStyleObject
	}
} = {
	container: {
		base: {
            bg: "#1E1E1E",
			height: '72px'
		}
	}
};